export const dialogTypeStyle = {
  default: {
    padding: 0,
    width: '100%',
    '& .MuiDialogContent-root': {
      margin: 0,
    },
  },
  confirmation: {
    height: 'auto',
    width: 'auto',
  },
  defaultStepper: {
    height: '300px',
  },
  scrollable: {
    padding: 0,
    height: '400px',
    width: '500px',
    '& .MuiDialogTitle-root': {
      marginBottom: 0,
    },
    '& .MuiDialogContent-root': {
      padding: '24px 40px 0px 40px',
      margin: 0,
    },
    '& .MuiDialogActions-root': {
      padding: '16px 16px 16px 40px',
      boxShadow: '0px 2px 8px 1px rgba(0, 0, 0, 0.16)', // TODO theme box shadow
      justifyContent: 'flex-end',
    },
  },
  scrollableWithTitle: {
    padding: 0,
    height: '400px',
    width: '500px',
    '& .MuiDialogTitle-root': {
      padding: '24px 40px 8px 40px',
      boxShadow: '0px 2px 8px 1px rgba(0, 0, 0, 0.16)', // TODO theme box shadow
      marginBottom: 0,
    },
    '& .MuiDialogContent-root': {
      padding: '16px 40px 0px 40px',
      margin: 0,
    },
    '& .MuiDialogActions-root': {
      padding: '16px 16px 16px 40px',
      boxShadow: '0px 2px 8px 1px rgba(0, 0, 0, 0.16)', // TODO theme box shadow
      justifyContent: 'flex-end',
    },
  },
};

export const dialogTypeSize = {
  small: {
    maxWidth: '516px',
  },
  medium: {
    maxWidth: '775px',
    maxHeight: '600px',
  },
  large: {
    maxWidth: '912px',
  },
  extraLarge: {
    maxWidth: { xs: '100vw', sm: '1156px' },
  },
  fullWidth: {
    width: '100vw',
  },
};
